import BitIconSpinner from '@narvar/nth-bit-icon-spinner';
import Button from '@narvar/nth-block-button';
import React, { FC, useContext } from 'react';
import CustomComponentContext from '../../CustomComponentContext';
import TextLink from '../../TextLink';
import {
  StyledCancelBtnContainer,
  StyledNavContainer,
  StyledSecondarySpinnerContainer,
  StyledSubmitBtnContainer,
} from '../styled';
import { TPanel } from '../types';
import { useTranslator } from '../utils/translator';

interface IProps {
  panel: TPanel;
  loading: boolean;
  submitDisabled?: boolean;
  onSubmit: () => Promise<void>;
  onCancel: () => void;
}

const PanelNav: FC<IProps> = (props) => {
  const { track } = useContext(CustomComponentContext);
  const { panel, loading, submitDisabled, onSubmit, onCancel } = props;

  const { t } = useTranslator();
  if (panel !== 'prompt' && panel !== 'form') return null;

  const scheduleDeliveryScheduleButtonText = t('Schedule Delivery');
  const scheduleDeliveryCancelLinkText = t('Cancel');

  const handleSubmitClick = () => {
    if (panel === 'prompt') {
      track({
        eventType: 'click',
        clickSubType: 'scheduledDeliveryPromptButtonClick',
      });
    }

    if (panel === 'form') {
      track({
        eventType: 'click',
        clickSubType: 'scheduledDeliveryScheduleButtonClick',
      });
    }

    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    onSubmit();
  };

  const handleCancelClick = () => {
    track({
      eventType: 'click',
      clickSubType: 'scheduledDeliveryCancelClick',
    });

    onCancel();
  };

  return (
    <StyledNavContainer>
      <StyledSubmitBtnContainer>
        <Button
          big
          disabled={submitDisabled || loading}
          onClick={handleSubmitClick}
        >
          {scheduleDeliveryScheduleButtonText}
        </Button>
      </StyledSubmitBtnContainer>
      {loading && (
        <StyledSecondarySpinnerContainer>
          <BitIconSpinner />
        </StyledSecondarySpinnerContainer>
      )}
      {panel !== 'prompt' && (
        <StyledCancelBtnContainer>
          <TextLink onClick={handleCancelClick}>
            {scheduleDeliveryCancelLinkText}
          </TextLink>
        </StyledCancelBtnContainer>
      )}
    </StyledNavContainer>
  );
};

export default PanelNav;
